<template>
    <div>
        <div class="mt10 mb10" v-if="bizParamGroupList == null || bizParamGroupList.length <= 0">
            <span>暂无业务参数需要维护</span>
        </div>
        <div v-else>
            <template v-for="bizParamGroup in bizParamGroupList">
                <div class="content-caption dashed">
                    <span>{{bizParamGroup.name}}</span>
                </div>
                <div v-if="bizParamGroup.bizParamList == null || bizParamGroup.bizParamList.length <= 0">
                    <span>暂无业务参数需要维护</span>
                </div>
                <div class="setting-info" v-else>
                    <div class="setting-row" v-for="bizParam in bizParamGroup.bizParamList">
                        <div class="setting-value" v-if="bizParam.merchantBizParam == null">
                            <swb-pattern-input class="inline-block" :pattern="bizParam.pattern" :initValue="bizParam.defValue" :inputType="bizParam.inputType" :valueType="bizParam.typeName" :ref="bizParam.code"></swb-pattern-input>
                            <span class="inline-block ml10">描述：{{bizParam.desc || '无'}}</span>
                        </div>
                        <div class="setting-value" v-else>
                            <swb-pattern-input class="inline-block" :pattern="bizParam.pattern" :initValue="bizParam.merchantBizParam.value" :inputType="bizParam.merchantBizParam.inputType" :valueType="bizParam.merchantBizParam.typeName" :ref="bizParam.code"></swb-pattern-input>
                            <span class="inline-block ml10">描述：{{bizParam.desc || '无'}}</span>
                        </div>
                    </div>
                </div>
            </template>
            <div class="form-toolbar">
                <button class="swb-btn swb-btn-small" @click="addMerchantBizParam()">保存</button>
            </div>
        </div>
    </div>
</template>
<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'
    import merchtComnApi from '../../api/merchtComn'

    export default {
        name: 'swb-merchant-biz-param-list',
        path: '/biz/param/list',
        avlActions: '',
        avlScopes: 'servicer',
        desc: '业务参数列表(商户用)',
        props: {
            groupCodeList: {
                type: Array,
                default: []
            }
        },
        data: function () {
            return {
                bizParamGroupList: []
            }
        },
        created: function () {
            //
            this.getBizParamGroupListByFilter();
        },
        methods: {
            getBizParamGroupListByFilter: function () {
                let self = this;
                let postData = {
                    codeList: this.groupCodeList,
                };
                merchtComnApi.getBizParamGroupList(postData, function (result) {
                    if(result.type == "info") {
                        let bizParamGroupList = result.data;
                        for(let i = 0; i < bizParamGroupList.length; i++) {
                            let bizParamGroup = bizParamGroupList[i];
                            let bizParamList = bizParamGroup.bizParamList;
                            for(let j = 0; j < bizParamList.length; j++) {
                                let bizParam = bizParamList[j];
                                // 去除掉指派网点策略
                                if(bizParam.code == "servc.shop.auto.dispatch.enabled") {
                                    bizParamList.splice(j, 1);
                                }
                            }
                        }
                        self.bizParamGroupList = bizParamGroupList;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            addMerchantBizParam: function () {
                let self = this;
                let bizParamGroup = self.bizParamGroupList;
                let merchantBizParamList = [];
                for(let i = 0; i < bizParamGroup.length; i++) {
                    //
                    let bizParamList = bizParamGroup[i].bizParamList;
                    for(let j = 0; j < bizParamList.length; j++) {
                        let bizParam = bizParamList[j];
                        //
                        let value = self.$refs[bizParam.code][0].getValue();
                        let merchantBizParam = {};
                        if(bizParam.merchantBizParam != null) {
                            merchantBizParam = bizParam.merchantBizParam;
                            merchantBizParam.value = value;
                        } else {
                            merchantBizParam.defId = bizParam.id;
                            merchantBizParam.code = bizParam.code;
                            merchantBizParam.groupCode = bizParam.groupCode;
                            merchantBizParam.typeName = bizParam.typeName;
                            merchantBizParam.value = value;
                            merchantBizParam.desc = bizParam.desc;
                        }
                        merchantBizParamList.push(merchantBizParam);

                    }
                }
                if(!Utils.isNoB(merchantBizParamList) && merchantBizParamList.length > 0) {
                    let merchantBizParamInfo = {};
                    merchantBizParamInfo.merchantBizParamList = merchantBizParamList;
                    merchtComnApi.saveMerchantBizParam(merchantBizParamInfo, function (result) {
                        if(result.type == 'info') {
                            MsgBox.success("保存成功！");
                            self.getBizParamGroupListByFilter();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    })
                } else {
                    MsgBox.warning("没有需要设置的参数");
                }
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/bizParam/MerchantBizParamList.vue